import { storage } from './storage';

export default class WebStorage {
  constructor({
    prefix = `remax.${window.location.hostname}.`,
    webstorage = storage,
  } = {}) {
    this.storage = webstorage;
    this.prefix = prefix;
  }

  keyGen = key => {
    return this.prefix + key;
  };

  set(key, value) {
    key = this.keyGen(key);
    this.storage.setItem(key, value);
    return Promise.resolve();
  }

  get(key) {
    key = this.keyGen(key);
    let item = this.storage.getItem(key);
    return Promise.resolve(item);
  }

  remove(key) {
    key = this.keyGen(key);
    const item = this.storage.getItem(key);
    this.storage.removeItem(key);
    return Promise.resolve(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/WebStorage/index.js